<ul class="nav level-2" *ngIf="selectedForms?.size">
  <cc-dropdown
    placement="bottom-left"
    data-test="export-csv-dropdown"
    autoClose="outside"
    focusOnOpen="none"
    class="nav-item"
    dropdownMenuClass="-sm-mt-[1px]"
    toggleButtonClass="sm-flex sm-items-center"
  >
    <a
      class="avatar-nav-link nav-link sm-flex sm-items-center sm-h-full"
      id="toolbar-export-csv"
      dropdownToggle
    >
      <i class="cc-icon cc-icon-download-csv"></i><span i18n>Download CSV</span>
      <i class="cc-icon cc-icon-arrow-down-small"></i>
    </a>

    <cc-dropdown-item
      (select)="exportCsvVisibleColumns.emit()"
      dropdownItem
      data-test="toolbar-export-csv-visible-columns"
    >
      <div class="action-dropdown-item">
        <span i18n>Visible register view columns only</span>
        <cc-tool-tip [contentText]="downloadCsvVisibleColumnsInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item
      (select)="exportCsvAllColumns.emit()"
      dropdownItem
      data-test="toolbar-export-csv-all-columns"
    >
      <div class="action-dropdown-item">
        <span i18n>All columns</span>
        <cc-tool-tip [contentText]="downloadCsvAllColumnsInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>
  </cc-dropdown>
  <cc-dropdown
    placement="bottom-left"
    data-test="download-pdf-dropdown"
    autoClose="outside"
    focusOnOpen="none"
    class="nav-item"
    toggleButtonClass="sm-flex sm-items-center"
    dropdownMenuClass="-sm-mt-[1px]"
  >
    <a
      class="avatar-nav-link nav-link sm-flex sm-items-center sm-h-full"
      id="toolbar-download-pdf"
      dropdownToggle
    >
      <i class="cc-icon cc-icon-download-pdf"></i><span i18n>Download PDF</span>
      <i class="cc-icon cc-icon-arrow-down-small"></i>
    </a>

    <cc-dropdown-item (select)="exportRegisterOnly.emit()" dropdownItem data-test="toolbar-export-register">
      <div class="action-dropdown-item">
        <span i18n>Register only</span>
        <cc-tool-tip [contentText]="downloadRegisterOnlyInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item (select)="exportPDF.emit()" dropdownItem data-test="toolbar-export-pdf">
      <div class="action-dropdown-item">
        <span i18n>Register and forms</span>
        <cc-tool-tip [contentText]="exportRegViewInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item (select)="downloadPDF.emit()" dropdownItem data-test="toolbar-download-csv">
      <div class="action-dropdown-item">
        <span i18n>Forms only</span>
        <cc-tool-tip [contentText]="downloadFormsInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>

    <cc-dropdown-item
      (select)="exportPDFWithOriginalPhotos.emit()"
      dropdownItem
      data-test="toolbar-export-pdf-with-original-photos"
    >
      <div class="action-dropdown-item">
        <span i18n>Forms only with original photo files</span>
        <cc-tool-tip [contentText]="exportPDFWithOriginalPhotosInfo" placement="right"></cc-tool-tip>
      </div>
    </cc-dropdown-item>
  </cc-dropdown>
  <li class="nav-item" *ngIf="selectedForms.size && canEdit()">
    <a class="nav-link delete-button" id="toolbar-delete-selected" (click)="deleteSelected.emit()">
      <i class="cc-icon cc-icon-delete"></i>
      <span i18n>Delete Selected</span>
    </a>
  </li>
</ul>

<ul class="nav level-2" *ngIf="!selectedForms?.size">
  <span
    class="sm-flex sm-items-center sm-font-medium sm-px-2"
    [class.sm-mr-auto]="app.isOrganisationTemplate && !registerViewFilterCount?.value"
  >
    {{ app.name }}
  </span>

  <div
    class="sm-flex sm-items-center sm-py-3 sm-pr-1"
    [class.sm-mr-auto]="!isRegisterView || !registerViewFilterCount?.value"
    *ngIf="!app.isOrganisationTemplate && (isTablet() || !isMobile())"
  >
    <cc-state-toggle [defaultValue]="view" [theme]="stateToggleTheme" #stateToggle class="sm-bg-grey-3">
      <cc-state-toggle-item value="timeline" routerLink="../timeline" *ngIf="!isWorkflow">
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-timeline" aria-hidden="true"></i>
          <span i18n>Timeline</span>
        </div>
      </cc-state-toggle-item>
      <cc-state-toggle-item [value]="moduleViews.Workflow" routerLink="../workflow" *ngIf="isWorkflow">
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-workflow" aria-hidden="true"></i>
          <span i18n>Workflow</span>
        </div>
      </cc-state-toggle-item>
      <cc-state-toggle-item [value]="moduleViews.Register" routerLink="../register">
        <div class="sm-flex sm-items-center sm-space-x-1">
          <i class="cc-icon cc-icon-register" aria-hidden="true"></i>
          <span i18n>Register</span>
        </div>
      </cc-state-toggle-item>
    </cc-state-toggle>
  </div>

  <li class="nav-item" *ngIf="isRegisterView" [class.sm-mr-auto]="registerViewFilterCount?.value > 0">
    <button
      type="button"
      class="btn btn-secondary btn-sm sm-mx-2"
      id="toolbar-remove-filter"
      (click)="resetRegisterViewFilter.emit()"
      *ngIf="registerViewFilterCount.value > 0"
    >
      <i class="fa fa-refresh fa-fw"></i>
      <span class="hidden-sm-down" i18n>Remove Filter</span>
      <span class="filter-badge">{{ registerViewFilterCount.value }}</span>
    </button>
  </li>

  <li class="nav-item sm-pr-2" [class.hide-banner-md-screens]="isRegisterView && registerViewFilterCount.value > 0">
    <cc-flowsite-banner
      [templateName]="app?.name"
      [templatePath]="app?.path"
      [priority]="isRegisterView ? 2 : 1"
      parentComponent="apps-tool-bar"
    ></cc-flowsite-banner>
  </li>

  <li class="nav-item" *ngIf="isRegisterView">
    <cc-banner
      data-test="yes-no-and-text-cell-filter"
      badgeText="New"
      badgePosition="left"
      width="fit-content"
      size="sm"
      customClasses="sm-m-1"
      [showBadge]="true"
      [dismissible]="true"
      ccBannerLogic
      [bannerKey]="bannerKeys.YesNoAndTextCellFilter"
      [localStorageKey]="bannerMetadata[bannerKeys.YesNoAndTextCellFilter].localStorageKey"
      [priority]="1"
      parentComponent="apps-tool-bar"
    >
      <span i18n class="sm-line-clamp-2 sm-text-ellipsis sm-break-all">Filter by Yes/No and text cell!</span>
    </cc-banner>
  </li>

  <li class="nav-item" *ngIf="!isMobile() && isRegisterView">
    <a
      href="https://intercom.help/dashpivot/en/articles/4919369-register-view"
      target="_blank"
      *ngIf="isRegisterView"
      class="btn cc-btn-subtle-dark-gray help-text sm-space-x-1 sm-py-1 sm-px-2"
    >
      <i class="cc-icon cc-icon-question"></i><span>Learn about register view</span>
    </a>
    <a
      class="nav-link sm-flex sm-items-center"
      id="toolbar-edit-columns"
      (click)="registerViewSetting.emit()"
      *ngIf="canEdit()"
    >
      <i class="cc-icon cc-icon-columns"></i>
      <span class="hidden-sm-down" i18n>Edit Columns</span>
    </a>
  </li>

  <li class="nav-item">
    <a
      href="https://intercom.help/dashpivot/en/articles/2563157-setting-up-workflows"
      target="_blank"
      *ngIf="isWorkflow && !isRegisterView"
      class="btn cc-btn-subtle-dark-gray help-text sm-space-x-1 sm-py-1 sm-px-2"
      data-test="workflows-help-link"
    >
      <i class="cc-icon cc-icon-question"></i><span i18n>Learn about workflows</span>
    </a>
    <a
      class="nav-link edit-app-link"
      id="toolbar-edit-template"
      [class.disabled]="app.readOnly"
      *ngIf="!isMobile() && canEdit()"
    >
      <span
        *ngIf="!app.readOnly"
        (click)="!app.readOnly && onEdit()"
        data-test="edit-template-button"
        class="sm-flex sm-items-center sm-space-x-1"
      >
        <em aria-hidden="true" class="cc-icon cc-icon-pencil"></em>
        <span i18n class="hidden-sm-down">Edit Template</span>
      </span>
      <span *ngIf="app.readOnly" (mouseleave)="editTemplateTooltip.close()">
        <ng-template #tipContentEditTemplate>
          <p class="default-paragraph subtitle-text text-left mt-1 mb-0">
            {{ orgTemplateInfo }}
          </p>
          <span
            *ngIf="isCompanyController()"
            class="btn btn-primary btn-sm btn-home-folder my-2 btn-block"
            i18n
            (click)="navigateToCompany()"
            >Go to Home Folder
            <em aria-hidden="true" class="cc-icon cc-icon-link-view light"></em>
          </span>
          <span class="d-flex justify-content-start">
            <a
              href="https://intercom.help/dashpivot/en/articles/2944886-the-template-library"
              target="_blank"
              rel="noopener noreferrer"
              class="btn cc-btn-subtle-gray btn-sm btn-learn-more sm-my-2 sm-px-2 sm-py-1"
              *ngIf="!isCompanyController"
            >
              <i class="cc-icon cc-icon-question"></i> <span i18n>Learn more</span>
            </a>
          </span>
        </ng-template>
        <span
          placement="bottom-start"
          tooltipClass="tip-container initial-white-space tip-placement-tool-bar"
          id="edit-template-tooltip"
          [autoClose]="false"
          triggers="manual"
          #editTemplateTooltip="ngbTooltip"
          (mouseenter)="editTemplateTooltip.open()"
          [ngbTooltip]="tipContentEditTemplate"
          class="sm-flex sm-items-center sm-space-x-1"
        >
          <em aria-hidden="true" class="cc-icon cc-icon-pencil"></em>
          <span i18n class="hidden-sm-down">Edit Template</span>
        </span>
      </span>
    </a>
  </li>

  <li class="nav-item">
    <a
      id="toolbar-add-form"
      class="nav-link nav-btn-success"
      *ngIf="canAdd"
      routerLink="./new"
      queryParamsHandling="merge"
    >
      <span i18n>Add</span> <span> {{ app.instanceName }}</span>
    </a>
  </li>
</ul>
